import styles from './icon-card.module.css'
import { Search } from '../assets/search'
import { Phone } from '../assets/phone'
import { Store } from '../assets/store'
import { HomeDelivery } from '../assets/home-delivery'

export interface IconCardProps {
  icon: string
  title: string
  body: string
}

export const IconCard = ({ icon = 'search', title, body }: IconCardProps) => {
  const validIcons = ['search', 'phone', 'store', 'home-delivery']
  const isFallbackIcon = !validIcons.includes(icon)

  return (
    <div className={styles.iconCardWrapper}>
      <div className={styles.iconCard}>
        {icon === 'search' && <Search />}
        {icon === 'phone' && <Phone />}
        {icon === 'store' && <Store />}
        {icon === 'home-delivery' && <HomeDelivery />}
        {isFallbackIcon && <Search />}
      </div>
      <h3 className={styles.iconCardHeading}>{title}</h3>
      <p className={styles.iconCardBody}>{body}</p>
    </div>
  )
}
